import { action, observable, makeAutoObservable } from 'mobx';

export class SelectedLanguageState {
    @observable editedKey: string | null = null;
    @observable adding: boolean = false;

    @action onUpdate = (): void => {
        this.editedKey = null;
        this.adding = false;
    };

    @action onEditClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        const key = event.currentTarget.getAttribute('data-key');
        this.editedKey = key;
    };

    @action onCancelClick = (): void => {
        this.editedKey = null;
        this.adding = false;
    };

    @action onAddClick = (): void => {
        this.adding = true;
    };

    @action sortElement = (a: [string, string], b: [string, string]): number => {
        if (a[0] > b[0]) {
            return 1;
        }
        if (a[0] < b[0]) {
            return -1;
        }

        return 0;
    };

    constructor() {
        makeAutoObservable(this);
    }
}
